// extracted by mini-css-extract-plugin
export default {"wrapper":"bG3RV","content":"DS176","content--no-offset":"ySAQ6"};